import { Navigate } from "react-router";
import { useClientPortalConfigContext } from "../../context";
import { ClientPortalFeatureAccess } from "../../types/generated/models";
import { ROUTES } from "../../routes";

interface RouteGuardProps {
    feature: keyof ClientPortalFeatureAccess;
    children: React.ReactNode;
}

export default function RouteGuard({ feature, children }: RouteGuardProps) {
    const { clientPortalConfig } = useClientPortalConfigContext();

    if (!clientPortalConfig?.featureAccess?.[feature]) {
        return <Navigate to={ROUTES.NOT_AVAILABLE.urlPath} replace />;
    }

    return <>{children}</>;
}
